"use client";

import { usePathname } from "next/navigation";
import NProgress from "nprogress";
import { useEffect } from "react";

export default function TopLoader() {
  const pathname = usePathname();

  useEffect(() => {
    NProgress.start();
    const timer = setTimeout(() => {
      NProgress.done();
    }, 300); // pequeno delay para suavizar a transição
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}